<template>
  <a-modal
    ref="createModal"
    title="新增领料单"
    :width="950"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="加工组织" prop="desOrganizationCode" :rules="rules">
            <global-select
              v-model="formData.desOrganizationCode"
              :selectData="inventOrg"
              @change="onChangeOrg"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :disabled="isDisableOrganization"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="车间" prop="workCode" :rules="rules">
            <global-select
              :value.sync="formData.workCode"
              selectType="select"
              focusGet
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: formData.desOrganizationCode }"
              :totalNum="9999999999"
              @change="onChangeWorkCode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划单号" prop="orderNo" :rules="rules">
            <a-input v-model="formData.orderNo" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="半成品编码" prop="assemblyItemCode">
            <global-select
              :value.sync="formData.assemblyItemCode"
              selectType="selectAssembleSearch"
              requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              searchParam="itemCode"
              :setParams="{ itemType: 'ZCBCP' }"
              :dropdown-match-select-width="false"
              sourseField="res"
              :totalNum="9999999999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划数量" prop="planQuantity" :rules="rules">
            <a-input-number v-model="formData.planQuantity" :precision="0" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="申领原因" prop="applyReason" :rules="rules">
            <global-select
              v-model="formData.applyReason"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'MES_MATERIAL_REQUISITION_REASON' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工作中心" prop="workCenterCode" :rules="rules">
            <global-select
              :value.sync="formData.workCenterCode"
              selectType="selectAssembleSearch"
              searchParam="centerName"
              assembleLabel
              focusGet
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ workshopCode: formData.workCode }"
              @change="onChangeCenter"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="班组" prop="teamGroupCode" :rules="rules">
            <global-select
              ref="teamGroupCodeRef"
              :value.sync="formData.teamGroupCode"
              selectType="selectAssembleSearch"
              searchParam="teamName"
              focusGet
              assembleLabel
              requestApi="/bom/team/list"
              :selectItem="{ value: 'teamCode', label: 'teamName' }"
              :setParams="{ workshopCode: formData.workCode, centerCode: formData.workCenterCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="领料日期" prop="applyDate" :rules="rules">
            <a-date-picker v-model="formData.applyDate" valueFormat="YYYY-MM-DD 00:00:00" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="领料人" prop="applyUser" :rules="rules">
            <a-input v-model="formData.applyUser" allowClear :maxLength="100" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="title-text">请填写申领的材料信息</div>
    <a-form-model ref="listFormRef" :model="listForm" class="table-form">
      <lsMetable
        class="editMaterial"
        :columns="columns"
        :data-list="listForm.dataList"
        :scroll="{y:300}"
        :IsEdit="false"
        @addDataList="addDataList"
      >
        <template slot="itemCode" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.itemCode'" :rules="rules">
            <global-select
              v-model="record.itemCode"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              :setParams="{ itemType: 'YL' }"
              searchParam="itemCode"
              sourseField="res"
              :totalNum="9999999999"
              @change="(value, list) => onChangeMaterial(value, list, record)"
            />
          </a-form-model-item>
        </template>
        <template slot="requiredQuantity" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.requiredQuantity'" :rules="positiveNumRule">
            <a-input-number v-model="record.requiredQuantity" :precision="2" />
          </a-form-model-item>
        </template>
        <template slot="remarks" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.remarks'" :rules="rules">
            <a-input v-model="record.remarks" :maxLength="200" />
          </a-form-model-item>
        </template>
        <template slot="operation" slot-scope="{text,record,index}">
          <ls-cancel v-if="index > 0" @confirm="deleteList(record,index)" title="确定要删除吗?">
            <a-icon type="delete" title="删除"/>
          </ls-cancel>
        </template>
      </lsMetable>
    </a-form-model>
    <a-space slot="footer">
      <a-button @click="onClose">取消</a-button>
      <a-button @click="onConfirmAdd" :loading="confirmLoading" type="primary">确认新增工单</a-button>
      <a-button @click="onConfirmDispatch" :loading="confirmLoading" type="primary">确认并派工</a-button>
    </a-space>
  </a-modal>
</template>

<script>
import {
  apiConfirmDispatchRequisitionJobsCc,
  apiConfirmAddRequisitionJobsCc, apiGetBomTeam
} from '@/api/mes/workOrderManage/ticketsManageCc'
import { mapState } from 'vuex'
import { positiveNumValidate } from '@/views/mes/workOrderManage/ticketsManageCc/common'
export default {
  name: 'AddMaterialModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      formData: {},
      listForm: {
        dataList: []
      },
      // 表单校验
      rules: [
        { required: true, message: ' ', trigger: 'change' }
      ],
      positiveNumRule: [ { validator: positiveNumValidate } ],
      columns: [
        { dataIndex: 'itemCode', title: '物料信息', scopedSlots: { customRender: 'itemCode' }, width: 150 },
        { dataIndex: 'materialName', title: '物料名称', width: 150 },
        { dataIndex: 'materialUnit', title: '单位', width: 150 },
        { dataIndex: 'requiredQuantity', title: '申领数量', scopedSlots: { customRender: 'requiredQuantity' }, width: 150 },
        { dataIndex: 'remarks', title: '备注', scopedSlots: { customRender: 'remarks' }, width: 150 },
        { dataIndex: 'operation', title: '操作', scopedSlots: { customRender: 'operation' }, width: 90 }
      ]
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    }),
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    }
  },
  created () {
    this.formData = this.getInitData();
  },
  methods: {
    addDataList() {
      this.listForm.dataList.push(this.getInitRowData());
    },
    deleteList(record, index) {
      this.listForm.dataList.splice(index, 1);
    },
    onChangeDate() {
      this.$set(this.formData, 'teamGroupCode', undefined)
    },
    onChangeMaterial(value, list, record) {
      const mItem = list.find(item => item.selectedValue === value);
      record.materialName = mItem?.bringOutDataTwo;
      record.materialUnit = mItem?.bringOutDataOne;
    },
    show () {
      this.visible = true
      this.confirmLoading = false
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.reset()
    },
    getParams() {
      let passIs;
      this.$refs.listFormRef.validate(valid => {
        passIs = valid;
      })
      this.$refs.ruleForm.validate(valid => {
        passIs = passIs & valid;
      })
      if(this.listForm.dataList.length === 0) {
        this.$message.error('请填写领料信息');
        return false;
      }
      if(passIs) {
        return {
          ...this.formData,
          itemList: this.listForm.dataList
        }
      }
    },
    onConfirmAdd () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true;
      this.$emit('update:mainBtnLoading', true);
      apiConfirmAddRequisitionJobsCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('successCall')
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
        this.$emit('update:mainBtnLoading', false);
      })
    },
    onConfirmDispatch () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true
      this.$emit('update:mainBtnLoading', true);
      apiConfirmDispatchRequisitionJobsCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('successCall')
          // 刷新表单
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$emit('update:mainBtnLoading', false);
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.$refs.ruleForm.resetFields();
      this.formData = this.getInitData();
      this.listForm.dataList = [];
    },
    getInitData() {
      return {
        itemCode: undefined,
        desOrganizationCode: this.organizationCodeOrigin,
        workCode: undefined,
        orderNo: '',
        applyReason: undefined,
        workCenterCode: undefined,
        teamGroupCode: undefined,
        applyUser: '',
        applyDate: undefined
      }
    },
    getInitRowData() {
      return {
        itemCode: undefined,
        requiredQuantity: null,
        remarks: '',
        materialUnit: '',
        materialName: ''
      }
    },
    onChangeOrg() {
      this.formData.workCenterCode = undefined
      this.formData.teamGroupCode = undefined
      this.formData.workCode = undefined
    },
    onChangeCenter() {
      this.formData.teamGroupCode = undefined;
      this.$nextTick(() => {
        this.getTeam();
      })
    },
    onChangeWorkCode() {
      this.formData.workCenterCode = undefined
      this.formData.teamGroupCode = undefined
    },
    getTeam() {
      if(!this.formData.workCenterCode) {
        return;
      }
      const params = {
        centerCode: this.formData.workCenterCode,
        workshopCode: this.formData.workCode
      }
      apiGetBomTeam(params).then(res => {
        if(res.code === 200) {
          const { rows = [] } = res;
          const teamCode = rows[0]?.teamCode;
          if(teamCode) {
            this.formData.teamGroupCode = teamCode
            this.$refs.teamGroupCodeRef.selectList = [ rows[0] ]
          }
        }
      })
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
.table-form {
  /deep/ .ant-select {
    width: 130px;
  }

  input {
    width: 130px;
  }

  /deep/ .ant-input-number {
    width: 130px;
  }

  /deep/ .ant-calendar-picker {
    min-width: 130px !important;
  }

  /deep/ .ant-form-item-control {
    min-width: 130px !important;
  }
}
.title-text {
  font-size: 14px;
  font-weight: bolder;
}
</style>
